export default {
  DRAFT: 'DRAFT',
  ACTIVE: 'ACTIVE',
  DEACTIVATED: 'DEACTIVATED',
  PAUSED: 'PAUSED',
  SENT_FOR_APPROVAL: 'SENT_FOR_APPROVAL',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  APPROVED: 'APPROVED',
  ARCHIVED: 'ARCHIVED',
  RE_PLAN: 'RE_PLAN',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETE: 'COMPLETE',
  SENT_TO_PATIENT: 'SENT_TO_PATIENT',
} as const
